var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZoomOut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1416 6.33189H4.36643C4.28499 6.33189 4.21835 6.39853 4.21835 6.47997V7.59059C4.21835 7.67203 4.28499 7.73867 4.36643 7.73867H10.1416C10.2231 7.73867 10.2897 7.67203 10.2897 7.59059V6.47997C10.2897 6.39853 10.2231 6.33189 10.1416 6.33189ZM15.3985 14.1802L12.696 11.4777C14.9561 8.72156 14.7988 4.6382 12.2148 2.05603C9.47526 -0.685342 5.0254 -0.685342 2.27478 2.05603C-0.466592 4.80665 -0.466592 9.25651 2.27478 11.996C4.85695 14.5801 8.94031 14.7374 11.6965 12.4773L14.399 15.1798C14.4582 15.2316 14.5526 15.2316 14.6026 15.1798L15.3985 14.3838C15.4504 14.3339 15.4504 14.2395 15.3985 14.1802ZM11.2337 11.015C9.03472 13.2121 5.47334 13.2121 3.27433 11.015C1.07716 8.81597 1.07716 5.25459 3.27433 3.05558C5.47334 0.858413 9.03472 0.858413 11.2337 3.05558C13.4309 5.25459 13.4309 8.81597 11.2337 11.015Z",
    fill: "#404041"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoomOut);
export default __webpack_public_path__ + "static/media/ZoomOut.f1092218a234b9ac9ce4ab0aa86fe850.svg";
export { ForwardRef as ReactComponent };